import transform from "~/kernel/objects/transform";
import type SerializeType from "./SerializeType";
import parseDate from "~/kernel/dateTime/parseDate";

type TimeStamps = {
  createdAt: Date;
  updatedAt: Date;
};

type DbEntity = Record<string | number | symbol, unknown> & TimeStamps;

export default function createDbEntityDeserializer<T extends DbEntity>() {
  return (entity: SerializeType<T>) => {
    const { createdAt, updatedAt, ...rest } = entity;
    const timestamps: TimeStamps = transform(
      { createdAt, updatedAt },
      {
        createdAt: parseDate,
        updatedAt: parseDate,
      },
    );

    return {
      ...rest,
      ...timestamps,
    };
  };
}
